import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class BootstrapLoaderService {
  private readonly activeLabels = new Map<string, number>();
  private activeCount = 0;
  private readonly loadingSubject = new BehaviorSubject<boolean>(false);
  public readonly loading$ = this.loadingSubject.asObservable();

  public start(label: string): void {
    const current = this.activeLabels.get(label) ?? 0;
    this.activeLabels.set(label, current + 1);
    this.activeCount += 1;
    this.updateLoadingState();
  }

  public complete(label: string): void {
    const current = this.activeLabels.get(label);
    if (!current) {
      return;
    }

    if (current === 1) {
      this.activeLabels.delete(label);
    } else {
      this.activeLabels.set(label, current - 1);
    }

    this.activeCount = Math.max(0, this.activeCount - 1);
    this.updateLoadingState();
  }

  public track<T>(label: string, source$: Observable<T>): Observable<T> {
    this.start(label);
    return source$.pipe(finalize(() => this.complete(label)));
  }

  public isLoading(): boolean {
    return this.activeCount > 0;
  }

  private updateLoadingState(): void {
    const isLoading = this.activeCount > 0;
    if (this.loadingSubject.value !== isLoading) {
      this.loadingSubject.next(isLoading);
    }
  }
}
